// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"a937c94d","250":"73982c27","407":"d1dec15d","436":"f9447b20","453":"f394a27d","455":"8e77704e","501":"33c56950","595":"5addb6a1","596":"5f05841b","606":"bc77ce0a","691":"cf0cad7b","821":"60b01a5e","925":"4bae2e44","969":"397e3ea2"}[chunkId] + ".chunk.js";
};